var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVector(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6872 0H2.31285C1.03754 0 0 1.03147 0 2.29928V11.3952C0 12.663 1.03754 13.6945 2.31285 13.6945H12.0452V15.0475C12.0452 16.2701 13.5721 16.8245 14.3688 15.9056L16.2856 13.6945H17.6871C18.9624 13.6945 20 12.6631 20 11.3953V2.29928C20 1.03147 18.9625 0 17.6872 0ZM4.85657 8.30705C4.02208 8.30705 3.34564 7.63455 3.34564 6.80501C3.34564 5.97547 4.02212 5.30297 4.85657 5.30297C5.69102 5.30297 6.36751 5.97543 6.36751 6.80501C6.36751 7.63459 5.69102 8.30705 4.85657 8.30705ZM10 8.30705C9.16551 8.30705 8.48907 7.63455 8.48907 6.80501C8.48907 5.97547 9.16555 5.30297 10 5.30297C10.8345 5.30297 11.5109 5.97543 11.5109 6.80501C11.5109 7.63459 10.8345 8.30705 10 8.30705ZM15.1435 8.30705C14.309 8.30705 13.6325 7.63455 13.6325 6.80501C13.6325 5.97547 14.309 5.30297 15.1435 5.30297C15.978 5.30297 16.6544 5.97543 16.6544 6.80501C16.6544 7.63459 15.9779 8.30705 15.1435 8.30705Z",
    fill: "#BCC6D3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.4ee4393013cd3d6acc3cb7d9aaf875bb.svg";
export { ForwardRef as ReactComponent };